import { sendEvent } from "../utils/event";
import { useCurrentPos } from "./use-current-pos";

export function useSendEvent() {
  const { club, pos } = useCurrentPos();
  return (event: string, data?: any) => {
    sendEvent(event, {
      ...data,
      club: { id: club.id, name: club.name },
      pos: { id: pos.id, name: pos.name },
    });
  };
}
